import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import { EmptyLayout } from 'components/Layout';
import { Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import { resetPasswordFormValidations } from 'form-validations';
import { connect } from 'react-redux';
import { LoginAction, UIAction } from 'redux/actions';
import AlertMessage from 'components/AlertMessage';
import PageSpinner from 'components/PageSpinner';
import { Link } from 'react-router-dom';


const ForgotPassword = (props) => {

  let [values, setValues] = React.useState({});
  let [errors, setErrors] = React.useState({});
  let [isSubmitted, setIsSubmitted] = React.useState(false);
  let [isValid, setIsValid] = React.useState(true);
  let [showLoader, setShowLoader] = React.useState(false);
  const isFirstRender = React.useRef(true);


  React.useEffect(() => {
    if (isFirstRender.current) {
      props.showMessages(null);
      isFirstRender.current = false;
    }
  })

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (isValid) {
      props.resetPassword(values);
      setShowLoader(true);
    }
  }

  const handleChange = (event) => {
    setValues({
      ...values, [event.target.name]: event.target.value
    })
  };

  React.useEffect(() => {
    const validationErrors = resetPasswordFormValidations(values);
    isValid = Object.keys(validationErrors).length === 0;
    setIsValid(isValid);
    setErrors(validationErrors);
  }, [values]);

  React.useEffect(() => {
    setShowLoader(false);
    if (props.uiMessage && props.uiMessage.status === 'success') {
      setValues({});
      setIsSubmitted(false);
    }
  }, [props.uiMessage]);

  return (
    <EmptyLayout>

      <Row className={'login-page-row'} >
        {(showLoader) ? <PageSpinner />
          : <Col md={6} lg={4}>
            <div style={{ minHeight: 55 }}><AlertMessage /></div>

            <Card body className="login-card">
              <Form>
                <div className="text-center pb-4">
                  Reset Password
                </div>
                <div style={{ fontSize: 12, textAlign: 'center' }}>New Password will be sent to your email address</div>
                <FormGroup>
                  <Label for={'email'}></Label>
                  <Input
                    type="text"
                    name="email"
                    id="email"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={(values && values.email) ? values.email : ''}
                    placeholder={'Email'}
                  />
                  {(isSubmitted && errors.email && !values.email) && <FormFeedback >{errors.email} </FormFeedback>}
                </FormGroup>
                <Button
                  size="lg"
                  color="primary"
                  className="border-0"
                  block
                  onClick={handleSubmit}>
                  Reset Password
                </Button>
                <div style={{ textAlign: 'center', marginTop: 10 }} ><Link to={'/login'}>Login</Link></div>
              </Form>
            </Card>

          </Col>
        }
      </Row>
    </EmptyLayout>
  )
}

const mapStateToProps = (state) => ({
  passwordReset: (state.loginReducer && state.loginReducer.passwordReset) ? state.loginReducer.passwordReset : null,
  uiMessage: (state.uiReducer && state.uiReducer.uiMessage) ? state.uiReducer.uiMessage : null
});
const mapDispatchToProps = (dispatch) => ({
  resetPassword: (payload) => dispatch(LoginAction.resetPassword(payload)),
  showMessages: (payload) => dispatch(UIAction.showMessages(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

//export default LoginPage;

